var apiToken = 'CijdTZuyBVDePURSejQHGgfMsTjgfJSxarjJkWBo';
var axios = require('axios');

class Discogs {

    constructor() {
        this.titleToLabels = {};
        this.nameToLabelInfo = {};
        this.nameToLabel = {};
        this.idToReleases = {};
    }

    getLabels(title) {
        return new Promise((resolve, reject) => {
            if (this.titleToLabels[title] !== undefined) {
                resolve(this.titleToLabels[title]);
                return;
            }

            this.searchYoutubeTitle(title)
                .then((result) => {
                // get all the labels
                var data = [];
                if (result === null || result.label === undefined) {
                    resolve(data);
                }
                result.label.map((label) => this.getLabelInfo(label, (ret) => {
                    if (ret === null) {
                        resolve(data);
                        return;
                    }
                    var labelData = {
                        id: ret.id,
                        name: ret.name};
                    if ('images' in ret) {
                        labelData['thumbnail'] = ret.images[0].uri;
                    }
                    data.push(labelData);

                    this.titleToLabels[title] = data;
                    if (data.length == result.label.length) {
                        resolve(data);
                    } else {
                    }
                }));
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getReleaseInfo(discogsId) {
        return new Promise((resolve, reject) => {
            var url = 'https://api.discogs.com/releases/' + discogsId;
        axios.get(url)
            .then((ret) => {
                if (ret.data !== undefined) {
                    var results = ret.data;
                    resolve(results);
                } else {
                    resolve(undefined);
                }
            });
        });
    }

    searchRecords(recordName) {
        return new Promise((resolve, reject) => {
            console.log("searchinng name=", recordName);
            let query = recordName.split(/\s/g).join('+');
            var url = 'https://api.discogs.com/database/search?q=' + query + '&type=release&token=' + apiToken;
        axios.get(url)
            .then((ret) => {
                if (ret.data.results !== undefined) {
                    var results = ret.data.results;
                    resolve(results);
                } else {
                    resolve([]);
                }
            });
        });
    }

    searchLabel(labelName, callback) {
        if (this.nameToLabel[labelName] !== undefined) {
            return callback(this.nameToLabel[labelName]);
        }
        var query = labelName;
        query = query.split(/\s/g).join('+');
        var url = 'https://api.discogs.com/database/search?q=' + query + '&type=label&token=' + apiToken;
        axios.get(url)
            .then((ret) => {
                if (ret.data.results !== undefined) {
                    var result = ret.data.results[0];
                    this.nameToLabel[labelName] = result;
                    callback(result);
                }
            });

    }

    getLabelInfo(labelName, callback) {
        this.searchLabel(labelName, function (result) {
            var labelId = result.id
            var url = 'https://api.discogs.com/labels/' + labelId + '?token=' + apiToken;
            axios.get(url)
                .then(function (ret) {
                    callback(ret.data);
                })
                .catch(function (err) {
                    callback(null);
                });
        });
            
    }

    getLabelReleases(labelId, page) {
        return new Promise((resolve, reject) => {
            if (this.idToReleases[labelId + '_' + page] !== undefined) {
                resolve(this.idToReleases[labelId + '_' + page]);
                return;
            }
            var url = 'https://api.discogs.com/labels/' + labelId +
            '/releases?token=' + apiToken + '&page=' + page + '&per_page=8';
            axios.get(url)
                .then((ret) => {
                    this.idToReleases[labelId + '_' + page] = ret.data;
                    resolve(ret.data);
                })
                .catch(function (err) {
                    reject(err);
            });
        });
    }

    searchYoutubeTitle(youtubeTitle) {
        return new Promise((resolve, reject) => {
            var searchObject = parseTitleString(youtubeTitle);
            var query = searchObject.artist + ' - ' + searchObject.title;
            query = query.split(/\s/g).join('+');
            var url = 'https://api.discogs.com/database/search?q=' + query + '&token=' + apiToken;
            axios.get(url)
                .then(function (ret) {
                    var results = ret.data.results;
                    var earliestResult = null;
                    for (var i in results) {
                        if ((earliestResult == null ||
                             (results[i].year < earliestResult.year)) && 
                            results[i].title.includes(searchObject.title))
                        {
                            earliestResult = results[i];
                        }
                    }
                    if (earliestResult == null) {
                        // get the first result
                        for (var i in results) {
                            return resolve(results[i]);
                        }
                    }
                    resolve(earliestResult);
                })
                .catch(function (err) {
                    reject(err);
                });;
        });
    }
}

// TODO: provide an array of potential separators
// var SEPARATORS = [' - ', ' – ', ' -- ']
// note that these can have spaces, but sometimes do not
// TODO: output a testing dataset for changes to this function.

var TRACK_SEPARATOR = ' - ';
function parseTitleString(string, partsCallback) {
  var artist, title, credits = [];
  var string = string || '';

  function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }

  // TODO: load from datafile
    var baddies = ['Full Album', 'Full vinyl', 'LP', '[dubstep]', '(full album)', '[electro]', '[edm]', '[house music]',
    '[glitch hop]', '[video]', '[official video]', '(official video)',
    '(official music video)', '(lyrics)',
    '[ official video ]', '[official music video]', '[free download]',
    '[free dl]', '( 1080p )', '(with lyrics)', '(high res / official video)',
    '(music video)', '[music video]', '[hd]', '(hd)', '[hq]', '(hq)',
    '(original mix)', '[original mix]', '[lyrics]', '[free]', '[trap]',
    '[monstercat release]', '[monstercat freebie]', '[monstercat]',
    '[edm.com premeire]', '[edm.com exclusive]', '[enm release]',
    '[free download!]', '[monstercat free release]'];
  baddies.forEach(function(token) {
    string = string.replace(token + ' - ', '').trim();
    string = string.replace(token.toUpperCase() + ' - ', '').trim();
    string = string.replace(token.toLowerCase() + ' - ', '').trim();

    string = string.replace(token, '').trim();
    string = string.replace(token.toUpperCase(), '').trim();
    string = string.replace(token.toLowerCase(), '').trim();
  });

    string = string.replace(/ *\([^)]*\) */g, '').trim();
    string = string.replace(/ *\[[^)]*\] */g, '').trim();


  var parts = string.split( ' - ' );

  for (var i = 0; i < parts.length; i++) {
    if ( baddies.indexOf( parts[i].toLowerCase() ) >= 0 ) {
      parts.splice( i , 1 );
    }
  }

  if (parts.length == 2) {
    artist = parts[0];
    title = parts[1];
  } else if (parts.length > 2) {
    // uh...
    artist = parts[0];
    title = parts[1];
  } else {
    artist = parts[0];
    title = parts[0];
  }


  // one last pass
  baddies.forEach(function(baddy) {
    title  = title.replace( new RegExp( escapeRegExp(baddy) , 'i') , '').trim();
    artist = artist.replace( new RegExp( escapeRegExp(baddy) , 'i') , '').trim();
  });

  // look for certain patterns in the string
  credits.push(  title.replace(/(.*)\((.*) remix\)/i,       '$2').trim() );
  credits.push(  title.replace(/(.*) ft\.? (.*)/i,          '$1').trim() );
  credits.push(  title.replace(/(.*) ft\.? (.*)/i,          '$2').trim() );
  credits.push(  title.replace(/(.*) feat\.? (.*)/i,        '$1').trim() );
  credits.push(  title.replace(/(.*) feat\.? (.*)/i,        '$2').trim() );
  credits.push(  title.replace(/(.*) featuring (.*)/i,      '$2').trim() );
  credits.push(  title.replace(/(.*) \(ft (.*)\)/i,         '$1').trim() );
  credits.push(  title.replace(/(.*) \(ft (.*)\)/i,         '$2').trim() );
  credits.push(  title.replace(/(.*) \(feat\.? (.*)\)/i,    '$2').trim() );
  credits.push(  title.replace(/(.*) \(featuring (.*)\)/i,  '$2').trim() );
  credits.push( artist.replace(/(.*) ft\.? (.*)/i,          '$1').trim() );
  credits.push( artist.replace(/(.*) ft\.? (.*)/i,          '$2').trim() );
  credits.push( artist.replace(/(.*) feat\.? (.*)/i,        '$1').trim() );
  credits.push( artist.replace(/(.*) feat\.? (.*)/i,        '$2').trim() );
  credits.push( artist.replace(/(.*) featuring (.*)/i,      '$2').trim() );
  credits.push( artist.replace(/(.*) \(ft (.*)\)/i,         '$1').trim() );
  credits.push( artist.replace(/(.*) \(ft (.*)\)/i,         '$2').trim() );
  credits.push( artist.replace(/(.*) \(feat\.? (.*)\)/i,    '$1').trim() );
  credits.push( artist.replace(/(.*) \(featuring (.*)\)/i,  '$2').trim() );
  credits.push( artist.replace(/(.*) & (.*)/ig,             '$1').trim() );
  credits.push( artist.replace(/(.*) & (.*)/ig,             '$2').trim() );
  credits.push( artist.replace(/(.*) vs\.? (.*)/i,          '$1').trim() );
  credits.push( artist.replace(/(.*) vs\.? (.*)/i,          '$2').trim() );
  credits.push( artist.replace(/(.*) x (.*)/i,              '$1').trim() );
  credits.push( artist.replace(/(.*) x (.*)/i,              '$2').trim() );

  var creditMap = {};
  credits.forEach(function(credit) {
    if (credit !== title) { // temp., until we find out why title is in credits
      creditMap[ credit ] = credit;
    }
  });

  var output = {
      artist: artist
    , title: title
    , credits: Object.keys(creditMap)
  };

    return output;
}

export default Discogs;
